// extracted by mini-css-extract-plugin
module.exports = {"container":"Results_container__3oUMK"};